import { useLayoutEffect, useState, type RefObject } from 'react';

/**
 * SVG の表示幅（px）。リサイズに追従。未計測時は 0。
 * `rerunKey` を変えると再バインド（初回マウント時に ref がまだ無いケース向け）。
 */
export function useSvgClientWidth(
  svgRef: RefObject<SVGSVGElement | null>,
  rerunKey = 0
): number {
  const [w, setW] = useState(0);

  useLayoutEffect(() => {
    const el = svgRef.current;
    if (!el) return;

    const measure = () => setW(el.getBoundingClientRect().width);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [svgRef, rerunKey]);

  return w;
}
